const cn = {
  financialAidStatus: {
    UNSUBMITTED: '未提交',
    REVIEWING: '审核中',
    PASSED: '审核通过',
    FAILED: '审核未通过'
  },
  invoiceStatus: {
    PAID: '已支付',
    NOT_PAY: '未支付',
    NO_INVOICE: '未生成'
  },
  steps: {
    FRESHMAN_INFO: '个人资料确认',
    PROGRAM_MAJOR: '选择专业方向',
    GOODS: '公寓物品',
    UNIFORM: '服装尺寸',
    OPTIONAL: '可选项目',
    ROOM: '选择宿舍',
    INVOICE: '确认账单',
    FATHER: '父亲',
    MOTHER: '母亲',
    MALE: '男',
    FEMALE: '女'
  },
  paymentResultStatus: {
    SUCCESS: '支付成功!',
    NOT_SUCCESS: '支付失败!'
  },
  EUA: {
    school_name: '西安欧亚学院',
    school_short_name: '欧亚',
    train_station: '西安站'
  },
  BJGX: {
    school_name: '北京供销学校',
    school_short_name: '北京供销',
    train_station: '北京站'
  },
  room_personal_commitment: '我已阅读并同意住宿须知'
}
export default cn



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js